import React from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Radio, Typography } from '@mui/material';

const MultiItemTableQuestion = ({ question, answerOptions, answer, onAnswerChange, questionNumber }) => (
  <Box sx={{ mb: 6 }}>
    <Typography variant="body1" sx={{ mb: 2 }}>
      {questionNumber}. {question.text}
    </Typography>
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell />
            {question.items.map((item, index) => (
              <TableCell key={index} align="center" sx={{ fontWeight: 'bold' }}>
                {item}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {answerOptions.map((option) => (
            <TableRow key={option.value}>
              <TableCell>{option.label}</TableCell>
              {question.items.map((_, itemIndex) => (
                <TableCell key={itemIndex} align="center">
                  <Radio
                    checked={answer[itemIndex] === option.value}
                    onChange={
                      onAnswerChange === null ? null :
                      () => onAnswerChange(option.value, itemIndex)
                    }
                    value={option.value}
                    name={`q${questionNumber}-item${itemIndex}`}
                    color="primary"
                    disableRipple={onAnswerChange === null}
                    disableFocusRipple={onAnswerChange === null}
                    disableTouchRipple={onAnswerChange === null}
                  />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Box>
);

export default MultiItemTableQuestion;